import Keyb from "keyb"
import Joyp from "joyp"
import Pointer from "poin"
import Screenfull from "screenfull"
import Resize from "@frog/source/utility/Resize.js"

import Game from "@frog/source/models/Game.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/Navigation.js"
import Director from "@frog/source/juice/Director.js"
import Sequence from "@frog/source/models/Sequence.js"

import Dev from "@frog/source/models/admin/Dev.js"
import Step from "@frog/source/juice/Step.js"

import Stage from "@frog/source/models/Stage.js"
import Unit from "@frog/source/models/Unit.js"

export default new class App {
    constructor() {
        window.frog = window.frog || {}
        window.frog.app = this
    }
    update(delta) {
        if(Keyb.isPressed("<control>")
        && Keyb.isPressed("Q")) {
            Navigation.go("/title")
        }

        if(Keyb.isPressed("<shift>")
        && Keyb.wasJustPressed("F")) {
            Screenfull.toggle()
        }

        if(Navigation.state != undefined) {
            if(Navigation.state.screen == "ChapterScreen") {
                if(Dev.inProtoMode == true) {
                    Navigation.state.escape = undefined
                }
                if(Dev.inProtoMode == false
                && Keyb.wasJustPressed("<escape>", delta.ms)) {
                    if(Navigation.state.escape == undefined) {
                        Navigation.state.escape = {"section": "MainSection"}
                    } else if(Navigation.state.escape != undefined) {
                        if(Navigation.state.escape.section == "MainSection") {
                            Navigation.state.escape = undefined
                        } else if(Navigation.state.escape.section == "OptionsSection") {
                            Navigation.state.escape.section = "MainSection"
                        }
                    }
                }

                if(Navigation.state.escape != undefined) {
                    return // paused!!
                }
            }
        }

        if(this.game != undefined) {
            Game.update(this.game, delta)
        }
        if(this.previewChapter != undefined) {
            // this.previewChapter.update(delta)

            Director.updateSequence({
                "sequence": this.previewChapter.sequence,
                "delta": delta,
            })
        }

        if(Dev.inProtoMode != true
        && this.sequence != undefined) {
            Director.updateSequence({
                "sequence": this.sequence,
                "delta": delta,
            })

            if(Pointer.wasJustPressed("primary", true, delta.ms)
            || Keyb.wasJustPressed("<space>", delta.ms)
            || Joyp.wasJustPressed(0, "south-button", delta.ms)) {
                Sequence.seek(this.sequence)
            }
        }
    }
    load(app) {
        this.game = Game.load(app.game)
    }
    getActiveStage() {
        if(this.game != undefined
        && this.sequence != undefined
        && this.sequence.steps != undefined
        && this.sequence.steps[0] != undefined
        && this.sequence.steps[0].stage != undefined) {
            return this.sequence.steps[0].stage
        }
        if(this.game != undefined
        && this.sequence != undefined
        && this.sequence.steps != undefined
        && this.sequence.steps[0] != undefined
        && this.sequence.steps[0].omegastage != undefined) {
            return this.sequence.steps[0].omegastage
        }
        if(this.game != undefined
        && this.game.chapter != undefined) {
            return this.game.chapter.stage
        }
    }
}
